var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 683 370.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9b2c2c;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.08,15.88L116.9,327.87c-9.99,19.45,4.14,42.59,26.01,42.59h320.36c21.87,0,35.99-23.13,26.01-42.59L329.09,15.88c-10.87-21.18-41.14-21.18-52.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.68,286.77c0-12.83,5.5-19.55,19.85-19.55h17.41c14.05,0,19.55,6.72,19.55,19.55v15.58c0,12.83-5.5,19.55-19.55,19.55h-17.41c-14.36,0-19.85-6.72-19.85-19.55v-15.58ZM275.29,221.04v-102.26c0-8.25,3.36-12.22,13.44-12.22h28.71c10.38,0,13.75,3.97,13.75,12.22v102.26c0,16.49-10.08,27.49-26.88,27.49h-2.14c-16.8,0-26.88-11-26.88-27.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.13,345.87l16.64-32.41h-10.37c-27.24,0-49.4-22.16-49.4-49.4V101.86c0-27.24,22.16-49.4,49.4-49.4h144.37l20.54-40H89.4C40.23,12.46,0,52.69,0,101.86v162.2c0,46.18,35.49,84.48,80.55,88.96.53-2.4,1.38-4.8,2.58-7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M522.6,12.46h-170.74l20.54,40h150.21c27.24,0,49.4,22.16,49.4,49.4v162.2c0,27.24-22.16,49.4-49.4,49.4h-16.2l16.64,32.41c1.27,2.47,2.14,4.99,2.67,7.53,47.75-1.65,86.3-41.21,86.3-89.34V101.86c0-49.17-40.23-89.4-89.4-89.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M633.2,116.46h6.62c23.83,0,43.18,19.35,43.18,43.18v53.65c0,23.83-19.35,43.18-43.18,43.18h-6.62c-.66,0-1.2-.54-1.2-1.2V117.66c0-.66.54-1.2,1.2-1.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattWarn);
export default __webpack_public_path__ + "static/media/batt-warn.a3c8fa20fc2c22f97c4f1b2b7d156e79.svg";
export { ForwardRef as ReactComponent };